import * as actionTypes from "./cmsActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
const { REACT_APP_API_URL } = process.env;

export const fetchCms = (slug) => {
    return (dispatch) => {
        dispatch(fetchCmsInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/cms/slug?slug=${slug}`))
        .then((response) => {
            dispatch(fetchCmsSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchCmsFailure());
            checkError(error);
        })
    };
};

export const fetchCmsInit = () => ({
    type: actionTypes.FETCH_CMS
});

export const fetchCmsFailure = () => ({
    type: actionTypes.FETCH_CMS_FAILURE
});

export const fetchCmsSuccess = data => ({
    type: actionTypes.FETCH_CMS_SUCCESS,
    payload: { data }
});
